<template lang="pug">

  v-flex(xs12 sud-block-overlay)
      .sud-block-title {{doc.name}} ([Request: {{doc.id}}])
      app-card.document__card
        app-card-body.document__card-body
          template(v-if="doc.sendable.text")
            app-card-caption.sended-text(v-if="doc.sendable.text.indexOf('<body>')!=-1" v-html="doc.sendable.text.substring(doc.sendable.text.indexOf('<body>'),doc.sendable.text.indexOf('</body>'))")
            app-card-caption.sended-text(v-else v-html="doc.sendable.text")
          app-button-action.mt-2(@click="viewSendedFile()") 
            v-icon(left dark) attach_file
            | Документ запроса

          app-button-action.mt-2.ml-2(@click="printInfo()") Информация для печати

      div.pt-2(v-for="(r) in doc.docResponses" :key="r.id")
          .sud-block-title Ответ от {{ r.createdDate}} [ {{ r.subject }} ]
          CaseResponse(:docResponse="r" :sendChannel="doc.sendChannel" @verify="verifyResponse($event)" @view="viewEncResponse($event)")

      signDoc(v-model="dialog.sign" :doc="doc" :sigId="sigId" :part="part" @sendfail="showErrorSnack($event)" @ok="showSuccessSnack($event)")

      v-snackbar(v-model="errorSnack" color="error" :timeout="6000" vertical top) {{errorSnackText}}
        v-btn(light text @click="errorSnack = false") Закрыть
      v-snackbar(v-model="successSnack" color="success" :timeout="6000" vertical top) {{successSnackText}}
        v-btn(light text @click="successSnack = false") Закрыть
            
</template>

<script>
import { mapGetters } from 'vuex'
import CaseResponse from './CaseResponse'
import { $sign_verifyResponse } from '../../signature/components/sign'
import signDoc from '../../signature/components/SignDoc'

export default {
  components: {
    CaseResponse,
    signDoc
  },
  props: {
    caseId: null,
  },
  computed: {
    ...mapGetters('courtCase', {doc: 'currentDoc'}),
  },
  methods: {
    showErrorSnack(text) {
      this.errorSnackText = text
      this.errorSnack = true
    },

    showSuccessSnack(text) {
      this.successSnackText = text
      this.successSnack = true
    },

    verifyResponse(part) {
      if(part.partName.indexOf('.enc') != -1){
        this.part = part 
        this.sigId = part.sigId
        this.dialog.sign = true
      } else 
        $sign_verifyResponse(part.partId, part.sigId, this.showSuccessSnack, this.showErrorSnack)
    },

    viewEncResponse (part) {
        this.part=part
        this.sigId = null
        this.dialog.sign = true
    },

    viewSendedFile () {
      let { sendable } = this.doc
      if (sendable && sendable.result) {
        let link="ms-word:ofv|u|"+document.location.origin+sendable.result
        window.open(link, '_self')
      }
    },

    printInfo () {
      let route = this.$router.resolve(`${this.doc.id}/docprint`)
      window.open(route.href, '_blank')
    },

  },
  data () {
    return {
      resp: "",
      load: false,
      errorSnackText: "Ошибка при подписании",
      successSnackText: "Подпись верна",
      errorSnack: false,
      successSnack: false,
      part: null,
      sigId: null,
      dialog: {
        sign: false
      }
    }
  }

}
</script>

<style lang="scss">
.sended-text h1 {margin:1rem 0;}
</style>
